import { fetcher } from '@commenda/utils';

import {
  ICreateIndirectTaxCredentialParams,
  ICreateIndirectTaxCredentialResponse,
} from './types';

export async function createIndirectTaxCredential(
  params: ICreateIndirectTaxCredentialParams,
  token?: string
): Promise<{
  success: boolean;
  data?: ICreateIndirectTaxCredentialResponse;
  error?: string;
}> {
  try {
    const response = await fetcher(
      'new-sales-tax/credentials',
      { method: 'POST', body: params },
      token
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to create credential',
      };
    }

    const data: ICreateIndirectTaxCredentialResponse = await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to create credential';
    return {
      success: false,
      error: errorMessage,
    };
  }
}
